import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';

import { useIsMobile } from '../../hooks';
import MobileDrawer from '../../shared_components/MobileDrawer/MobileDrawer';
import { BaseModal } from '../index';
import Preloader from '../Preloader/Preloader';

import styles from './SwitchingAccountPopup.module.scss';

type OwnProps = {
  setIsDisplayModal: (status: boolean) => void;
  isDisplayModal: boolean;
  onComplete?: () => void;
};

type Props = OwnProps & ReduxProps;

const SwitchingAccountPopup = (props: Props): JSX.Element => {
  const { isDisplayModal, setIsDisplayModal, isUseDemoAccount, isSwitchingAccount, onComplete } = props;
  const { isMobile } = useIsMobile();

  useEffect(() => {
    if (isSwitchingAccount) return;

    setIsDisplayModal(false);
    onComplete?.();
  }, [isSwitchingAccount, isUseDemoAccount]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderContent = () => (
    <div className={styles.loader} id="switchingAccountPopup">
      <Preloader
        isFullScreen
        text={!isUseDemoAccount ? lang.commonMessageSwitchingFundedPlan() : lang.commonMessageSwitchingDemoPlan()}
        owner="Sidebar"
      />
    </div>
  );

  if (isMobile) {
    return (
      <MobileDrawer
        isOpen={isDisplayModal}
        onClose={() => setIsDisplayModal(false)}
        title=""
        showTitle={false}
        showCloseButton={false}
      >
        {renderContent()}
      </MobileDrawer>
    );
  }

  return (
    <BaseModal
      className={styles.modal}
      isOpen={isDisplayModal}
    >
      {renderContent()}
    </BaseModal>
  );
};

const mapStateToProps = (state: RootState) => ({
  isUseDemoAccount: state.crm.isUseDemoAccount,
  isSwitchingAccount: state.crm.isSwitchingAccount,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(SwitchingAccountPopup);
